import {
  Information,
  defaultInformationProps
} from '@/src/components/HomePage/Information'
import { RootState, SLICE_NAME } from '@/src/redux/store'
import { Services, ServicesProps } from '@/src/components/HomePage/Services'
import { useEffect, useState } from 'react'

import AffiliateReviews from '@/src/components/ExploreOrkaTwo/AffiliateReviews'
import BlueTooth from '@/src/components/ExploreOrkaTwo/Bluetooth'
import { Box } from '@mui/material'
import BuyOrkaTwoBanner from '@/src/components/Account/OrkaTwo/BuyOrkaTwoBanner'
import Design from '@/src/components/ExploreOrkaTwo/Design'
import Footer2 from '@/src/components/Footer/Footer2'
import Header from '@/src/components/HeaderV2/index'
import Hero from '@/src/components/ExploreOrkaTwo/Hero'
import { NextSeo } from 'next-seo'
import ProductSheetPopUp from '@/src/components/ProductSheet/ProductSheetPopUp'
import PromotionSection from 'src/components/BuyOrkaTwo/PromotionSection'
import QualityWithLowPriceSection from '@/src/components/ExploreOrkaTwo/QualityWithLowPriceSection'
import Solution from '@/src/components/ExploreOrkaTwo/Solution'
import Technology from '@/src/components/ExploreOrkaTwo/Technology'
import { cloneDeep } from 'lodash'
import { getEnvVar } from '@/env'
import styles from './styles.module.scss'
import { useSelector } from 'react-redux'

const data: { services: ServicesProps } = {
  services: {
    CTAText: 'Try Now',
    CTAHref: '/Product/buy-orka-two',
    pageId: 'explore-orka-two-page'
  }
}

const getCheckoutPath = (email = '') => {
  const payload = [
    {
      quantity: 1,
      product_id: getEnvVar('NEXT_PUBLIC_GOODS_ID'),
      email
    }
  ]
  const path = `/Checkout?bigcommerce=${encodeURIComponent(
    JSON.stringify(payload)
  )}`
  return path
}

function ExploreOrkaTwo() {
  const [headerTransform, setHeaderTransform] = useState(0)
  const headerHeight = useSelector(
    (state: { header: { height: string | number } }) => state.header.height
  )
  const userEmail = useSelector(
    (state: RootState) => state[SLICE_NAME].userInfo.email
  )

  useEffect(() => {
    const firstScreenHeight = window.innerHeight
    let lastScrollPosition = 0
    const handleScroll = () => {
      const currentScrollPosition = window.scrollY
      const enableHeaderTransform =
        currentScrollPosition > firstScreenHeight &&
        currentScrollPosition > lastScrollPosition
      setHeaderTransform(enableHeaderTransform ? -100 : 0)
      lastScrollPosition = currentScrollPosition
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const getInformationProps = () => {
    const props = cloneDeep(defaultInformationProps)
    props.title = 'Need More Information?'
    props.pageId = data.services.pageId
    props.sections[0] = {
      ...props.sections[0],
      subtitle: 'Purchase Orka Two',
      CTAText: 'Continue to Checkout',
      CTAType: 'Button',
      CTAHref: getCheckoutPath(userEmail || '')
    }
    return props
  }

  return (
    <Box>
      <NextSeo
        title="Orka Two Hearing Aids | Buy Online - FDA-Registered, Bluetooth 5.3, Rechargeable, Fast Charge"
        description="Built from scratch, Orka Two is the next-generation AI-empowered hearing aid using advanced technologies to enhance audio experiences."
      />
      <Header
        disableFirstScreenCheck
        isWhiteBg
        sx={{
          position: 'relative',
          transform: headerTransform ? `translateY(${headerTransform}%)` : 0,
          transition: 'transform 500ms ease-in-out'
        }}
      />
      <Hero />
      <Technology />
      <Solution />
      <Design />
      <BlueTooth />
      <QualityWithLowPriceSection />
      <AffiliateReviews />
      <Footer2 />
    </Box>
  )
}

export default ExploreOrkaTwo
